import { FC } from 'react';

import { text } from './Text.styles';
import type { TextProps } from './Text.types';

export const Text: FC<TextProps> = ({ size, weight, color, align, truncate, className, children }) => (
	<span className={text({ size, weight, color, align, truncate, className })}>{children}</span>
);
